
import { Component, Prop, Vue } from "vue-property-decorator";
import { Breadcrumb } from "./types";

@Component
export default class Breadcrumbs extends Vue {
    @Prop() title!: string;
    @Prop({ default: () => [] }) breadcrumbs!: Breadcrumb[];
}
